export default __webpack_public_path__ + "static/media/ExistingQuestionnaire.983c982e.svg";